import React from 'react'
import Layout from '../../components/layout/Layout'
import OrdersMainTable from '../../elements/tables/orders/OrdersMainTable'

export default function OrderMain() {
  return (
    <div>
      <Layout>
        <OrdersMainTable />
      </Layout>
    </div>
  )
}
